// src/hooks/usePageVisibility.ts
import { useState, useEffect } from 'react';

export default function usePageVisibility() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const hidden = document.hidden;
      setIsVisible(!hidden);
      
      console.log('📱 Visibilité:', !hidden ? 'Visible' : 'Cachée');
      
      if (hidden) {
        console.log('🔴 L\'onglet est caché ou en arrière-plan');
      } else {
        console.log('🟢 L\'onglet est visible');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Vérifier l'état initial
    setIsVisible(!document.hidden);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { isVisible };
}